export default "__VITE_ASSET__Yrg2ZKsn__"